/**
 * Post-wizard guided tour (Update 24, Change 3b) — lazy-loads driver.js.
 * Highlights the Open Days → Tickets → Branding sidebar items, then opens Branding.
 */
export const TOUR_KEY = "scaretickets_tour_completed";

export function tourCompleted() {
  try { return localStorage.getItem(TOUR_KEY) === "true"; } catch { return false; }
}

function markDone() {
  try { localStorage.setItem(TOUR_KEY, "true"); } catch { /* ignore */ }
}

export async function startBrandingTour({ openDays = 0, ticketTypes = 0, navigate }) {
  const { driver } = await import("driver.js");
  await import("driver.js/dist/driver.css");

  const d = driver({
    allowClose: true,
    overlayColor: "rgba(0,0,0,0.72)",
    stagePadding: 6,
    stageRadius: 8,
    popoverClass: "st-tour",
    showProgress: false,
    nextBtnText: "Next →",
    prevBtnText: "← Back",
    doneBtnText: "Open Branding →",
    steps: [
      {
        element: '[data-testid="nav-open-days"]',
        popover: {
          title: "Your Open Days",
          side: "right", align: "start",
          description: `You added ${openDays} open day${openDays === 1 ? "" : "s"} in the wizard. You can add, edit or manage them here at any time.<div class="st-tour-stat">${openDays} open day${openDays === 1 ? "" : "s"} configured</div>`,
        },
      },
      {
        element: '[data-testid="nav-tickets"]',
        popover: {
          title: "Your Tickets",
          side: "right", align: "start",
          description: `Your ticket types and time-slot performance live here. You can adjust prices, capacity and add new ticket types.<div class="st-tour-stat">${ticketTypes} ticket type${ticketTypes === 1 ? "" : "s"} created</div>`,
        },
      },
      {
        element: '[data-testid="nav-branding"]',
        popover: {
          title: "Brand Your Booking Page",
          side: "right", align: "start",
          description: "Customise how your booking page looks to customers. Choose a template, add your logo and set your colours.",
          onNextClick: () => { markDone(); d.destroy(); if (navigate) navigate("/dashboard/branding"); },
        },
      },
    ],
    onCloseClick: () => { markDone(); d.destroy(); },
    onDestroyed: () => { markDone(); },
  });

  d.drive();
  return d;
}
